import { useMemo } from 'react';
import { OptionsObject, useSnackbar } from 'notistack';

export const useNotification = () => {
  const { enqueueSnackbar } = useSnackbar();
  return useMemo(
    () => ({
      success: (message: string, options?: OptionsObject<'success'>) =>
        enqueueSnackbar(message, { variant: 'success', ...options }),
      error: (message: string, options?: OptionsObject<'error'>) =>
        enqueueSnackbar(message, { variant: 'error', ...options }),
      warning: (message: string, options?: OptionsObject<'warning'>) =>
        enqueueSnackbar(message, { variant: 'warning', ...options }),
      info: (message: string, options?: OptionsObject<'info'>) =>
        enqueueSnackbar(message, { variant: 'info', ...options }),
    }),
    [enqueueSnackbar],
  );
};
